import { icons } from 'common'
import { BustedCard } from 'components/Organisms/MainGames/Busted/BustedCard'
import { AutoGptCard } from 'components/Organisms/MainGames/Leverage/AutoGptCard'
import { InfiniteWinningCard } from 'components/Organisms/MainGames/Leverage/InfiniteWinningCard'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

export const PAGE_CONTENT = {
  [CONTENT_TYPES.LVG_CRYPTO]: {
    title: 'Leveraged Crypto',
    color: '#2159d1',
    icon: icons.leveraged_crypto_icon,
    maskedIcon: true,
    content: <InfiniteWinningCard game={CONTENT_TYPES.LVG_CRYPTO} />,
  },
  [CONTENT_TYPES.LVG_STOCKS]: {
    title: 'Leveraged synthetic stocks',
    color: '#875CFF',
    icon: icons.leveraged_synth_stocks_icon,
    maskedIcon: true,
    content: <InfiniteWinningCard game={CONTENT_TYPES.LVG_STOCKS} />,
  },
  [CONTENT_TYPES.LVG_INDEXES]: {
    title: 'leveraged indexes',
    color: '#25CF43',
    icon: icons.leveraged_indexes_icon,
    maskedIcon: true,
    content: <InfiniteWinningCard game={CONTENT_TYPES.LVG_INDEXES} />,
  },
  [CONTENT_TYPES.G_BUSTED]: {
    title: 'Busted',
    color: '#aa0000',
    icon: icons.busted_icon,
    maskedIcon: true,
    content: <BustedCard />,
  },
  [CONTENT_TYPES.LVG_AI_INDEXES]: {
    title: 'gpt indexes',
    color: '#DE0ECD',
    icon: icons.ai_indexes_icon,
    maskedIcon: true,
    iconSize: '20px',
    content: <AutoGptCard />,
  },
}
